(() => {

  const getCleanText = (value) => (value || '').toString().trim();

  const normalizeAdvisorKey = (value) => (value || '').toString()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

  const estimateLaboschSize = (heightValue) => {
    const h = Number(heightValue) || 175;
    if (h < 154) return { label: 'XS', value: 'XS,S', primary: 'XS', noteKey: 'xs' };
    if (h < 168) return { label: 'S', value: 'S', primary: 'S', note: '' };
    if (h < 178) return { label: 'M', value: 'M', primary: 'M', note: '' };
    if (h < 188) return { label: 'L', value: 'L', primary: 'L', note: '' };
    if (h < 198) return { label: 'XL', value: 'XL', primary: 'XL', note: '' };
    return { label: 'XL', value: 'XL,XXL', primary: 'XL', noteKey: 'xxl' };
  };

  const buildLaboschFilterUrl = (quiz, state) => {
    const marketRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
    const base = quiz.getAttribute('data-lbx-catalog-url') || `${marketRoot}collections/bicicletas-electricas-ebikes-labosch?sort_by=manual&pb=0`;
    let url;
    try {
      url = new URL(base, window.location.origin);
    } catch (error) {
      url = new URL(`${marketRoot}collections/bicicletas-electricas-ebikes-labosch`, window.location.origin);
    }

    const params = new URLSearchParams(url.search);
    params.set('sort_by', params.get('sort_by') || 'manual');
    params.set('pb', params.get('pb') || '0');

    const category = normalizeAdvisorKey(state.categoryKey || state.category || '');
    const use = normalizeAdvisorKey(state.useKey || state.uso || '');
    const terrain = normalizeAdvisorKey(state.terrainKey || state.terreno || '');
    const priority = normalizeAdvisorKey(state.priorityKey || state.prioridad || '');
    const budget = normalizeAdvisorKey(state.budgetKey || state.presupuesto || '');
    const discipline = normalizeAdvisorKey(state.disciplineKey || state.terrainDiscipline || state.discipline || '');
    const size = getCleanText(state.sizeParam || state.talla || '');

    if (category && category !== 'guiado') params.set('lbx_cat', category);
    if (use) params.set('lbx_use', use);
    if (terrain) params.set('lbx_terrain', terrain);
    if (priority) params.set('lbx_priority', priority);
    if (budget && budget !== 'flexible') params.set('lbx_budget', budget);
    if (discipline) params.set('lbx_discipline', discipline);
    if (size) params.set('lbx_size', size);
    if (state.priceMin) params.set('lbx_price_min', state.priceMin);
    if (state.priceMax) params.set('lbx_price_max', state.priceMax);

    url.search = params.toString();
    return `${url.pathname}${url.search}`;
  };

  const initAdvisorModal = (quiz, scope) => {
    if (!quiz || quiz.dataset.lbxAdvisorReady === 'true') return;
    quiz.dataset.lbxAdvisorReady = 'true';

    const modalKey = (quiz.getAttribute('data-lbx-advisor-modal') || '').trim();
    const openScope = scope || document;
    const openers = Array.from(openScope.querySelectorAll('[data-lbx-quiz-open]')).filter((opener) => {
      const target = (opener.getAttribute('data-lbx-quiz-open') || '').trim();
      return !target || !modalKey || target === modalKey;
    });
    const closers = quiz.querySelectorAll('[data-lbx-quiz-close]');
    const steps = Array.from(quiz.querySelectorAll('[data-lbx-quiz-step]'));
    const prev = quiz.querySelector('[data-lbx-quiz-prev]');
    const next = quiz.querySelector('[data-lbx-quiz-next]');
    const progress = quiz.querySelector('[data-lbx-quiz-progress]');
    const counter = quiz.querySelector('[data-lbx-quiz-counter]');
    const summaryNodes = quiz.querySelectorAll('[data-lbx-summary]');
    const heightInput = quiz.querySelector('[data-lbx-quiz-height]');
    const heightOutput = quiz.querySelector('[data-lbx-height-output]');
    const sizeOutput = quiz.querySelector('[data-lbx-size-output]');
    const sizePill = quiz.querySelector('[data-lbx-size-pill]');
    const sizeNote = quiz.querySelector('[data-lbx-size-note]');
    const minus = quiz.querySelector('[data-lbx-height-minus]');
    const plus = quiz.querySelector('[data-lbx-height-plus]');
    const i18n = {
      pending: quiz.dataset.lbxI18nPending || 'Pending',
      question: quiz.dataset.lbxI18nQuestion || 'Pregunta',
      of: quiz.dataset.lbxI18nOf || 'de',
      next: quiz.dataset.lbxI18nNext || 'Next',
      apply: quiz.dataset.lbxI18nApply || 'Apply filters',
      xsNote: quiz.dataset.lbxI18nXsNote || '',
      xxlNote: quiz.dataset.lbxI18nXxlNote || ''
    };

    if (!steps.length) return;

    let current = 0;
    let lastFocused = null;
    let lockScrollY = 0;
    let previousScrollBehavior = '';
    const getCurrentColorScheme = () => {
      const htmlScheme = (document.documentElement.getAttribute('data-lbx-color-scheme') || '').trim();
      const bodyScheme = (document.body?.getAttribute('data-lbx-color-scheme') || '').trim();
      return htmlScheme === 'light' || htmlScheme === 'dark' ? htmlScheme : (bodyScheme === 'light' || bodyScheme === 'dark' ? bodyScheme : 'dark');
    };
    const syncQuizTheme = () => {
      const scheme = getCurrentColorScheme();
      quiz.setAttribute('data-lbx-theme', scheme);
      const portal = quiz.closest('[data-lbx-quiz-portal-root]');
      if (portal) portal.setAttribute('data-lbx-theme', scheme);
    };
    const displayState = {};
    const state = {
      uso: '',
      terreno: '',
      presupuesto: '',
      altura: heightInput ? heightInput.value : '175',
      talla: estimateLaboschSize(heightInput ? heightInput.value : 175).label,
      sizeParam: estimateLaboschSize(heightInput ? heightInput.value : 175).value,
      category: '',
      categoryKey: '',
      useKey: '',
      terrainKey: '',
      priorityKey: '',
      budgetKey: '',
      discipline: '',
      disciplineKey: '',
      terrainDiscipline: '',
      priceMin: '',
      priceMax: ''
    };

    const questionKeys = steps.map((step) => step.dataset.lbxQuestion || '');

    const setSummary = (key, value) => {
      summaryNodes.forEach((node) => {
        if (node.dataset.lbxSummary === key) node.textContent = value || i18n.pending;
      });
    };

    const updateHeight = (value) => {
      const min = heightInput ? Number(heightInput.min || 145) : 145;
      const max = heightInput ? Number(heightInput.max || 205) : 205;
      const nextValue = Math.min(max, Math.max(min, Number(value) || 175));
      const sizeInfo = estimateLaboschSize(nextValue);
      state.altura = String(nextValue);
      state.talla = sizeInfo.label;
      state.sizeParam = sizeInfo.value;
      if (heightInput) heightInput.value = String(nextValue);
      if (heightOutput) heightOutput.textContent = String(nextValue);
      if (sizeOutput) sizeOutput.textContent = state.talla;
      if (sizePill) sizePill.textContent = state.talla;
      if (sizeNote) {
        const localizedNote = sizeInfo.noteKey === 'xs' ? i18n.xsNote : (sizeInfo.noteKey === 'xxl' ? i18n.xxlNote : '');
        sizeNote.textContent = localizedNote;
        sizeNote.hidden = !localizedNote;
      }
      setSummary('talla', `${nextValue} cm · ${state.talla}`);
      updateNavState();
    };

    const updateSummary = () => {
      setSummary('tipo', displayState.tipo || state.tipo);
      setSummary('uso', displayState.uso || state.uso);
      setSummary('terreno', displayState.terreno || state.terreno);
      setSummary('presupuesto', displayState.presupuesto || state.presupuesto);
      setSummary('talla', `${state.altura} cm · ${state.talla}`);
    };

    const resetQuestion = (question) => {
      if (!question || question === 'altura') return;
      state[question] = '';
      displayState[question] = '';
      if (question === 'uso') state.useKey = '';
      if (question === 'terreno') state.terrainKey = '';
      if (question === 'prioridad') state.priorityKey = '';
      if (question === 'presupuesto') {
        state.budgetKey = '';
        state.priceMin = '';
        state.priceMax = '';
      }
      quiz.querySelectorAll(`[data-lbx-quiz-option][data-question="${question}"]`).forEach((item) => item.classList.remove('is-selected'));
    };

    const optionMatchesBranch = (option) => {
      const visibleFor = (option.getAttribute('data-visible-for') || '').split(',').map((item) => item.trim()).filter(Boolean);
      const visibleUse = (option.getAttribute('data-visible-use') || '').split(',').map((item) => item.trim()).filter(Boolean);
      const category = state.categoryKey || 'guiado';
      const use = state.useKey || '';
      if (visibleFor.length && !visibleFor.includes(category)) return false;
      if (visibleUse.length && !visibleUse.includes(use)) return false;
      return true;
    };

    const updateBranchOptions = () => {
      quiz.querySelectorAll('[data-lbx-quiz-option][data-visible-for]').forEach((option) => {
        const visible = optionMatchesBranch(option);
        option.hidden = !visible;
        option.classList.toggle('is-branch-hidden', !visible);
        option.setAttribute('aria-hidden', visible ? 'false' : 'true');
        option.style.display = visible ? '' : 'none';
        if (!visible) option.classList.remove('is-selected');
      });

      // LABOSCH v1007: assign stable visual positions only to currently visible cards.
      // Inline grid placement is intentional: older theme blocks contain !important nth-child
      // and auto-placement rules that can squeeze a visible card into one grid column.
      const applyCardPlacement = (group, visibleCards) => {
        const isType = group.classList.contains('lbxw-quiz__options--type-collage');
        const isPrice = group.classList.contains('lbxw-quiz__options--price');
        const count = visibleCards.length;
        const defaultPositions = {
          1: [['1 / span 12', '1']],
          2: [['1 / span 7', '1'], ['8 / span 5', '1']],
          3: [['1 / span 7', '1'], ['8 / span 5', '1'], ['1 / span 12', '2']],
          4: [['1 / span 6', '1'], ['7 / span 6', '1'], ['1 / span 5', '2'], ['6 / span 7', '2']],
          5: [['1 / span 4', '1'], ['5 / span 4', '1'], ['9 / span 4', '1'], ['1 / span 5', '2'], ['6 / span 7', '2']]
        };
        const typePositions = [
          ['1 / span 4', '1 / span 2'],
          ['5 / span 3', '1'],
          ['8 / span 5', '1'],
          ['5 / span 5', '2'],
          ['10 / span 3', '2']
        ];
        const pricePositions = [
          ['1 / span 5', '1'],
          ['6 / span 4', '1'],
          ['10 / span 3', '1'],
          ['1 / span 12', '2']
        ];
        const isMobileQuiz = window.matchMedia && window.matchMedia('(max-width: 760px)').matches;
        const mobilePositions = {
          1: [['1 / span 2', '1']],
          2: [['1 / span 1', '1'], ['2 / span 1', '1']],
          3: [['1 / span 2', '1'], ['1 / span 1', '2'], ['2 / span 1', '2']],
          4: [['1 / span 1', '1'], ['2 / span 1', '1'], ['1 / span 1', '2'], ['2 / span 1', '2']],
          5: [['1 / span 2', '1'], ['1 / span 1', '2'], ['2 / span 1', '2'], ['1 / span 1', '3'], ['2 / span 1', '3']]
        };
        const mobilePricePositions = {
          1: [['1 / span 2', '1']],
          2: [['1 / span 1', '1'], ['2 / span 1', '1']],
          3: [['1 / span 2', '1'], ['1 / span 1', '2'], ['2 / span 1', '2']],
          4: [['1 / span 1', '1'], ['2 / span 1', '1'], ['1 / span 1', '2'], ['2 / span 1', '2']]
        };
        const positions = isMobileQuiz
          ? (isPrice ? (mobilePricePositions[Math.min(count, 4)] || mobilePositions[Math.min(Math.max(count, 1), 5)]) : (mobilePositions[Math.min(Math.max(count, 1), 5)] || mobilePositions[5]))
          : (isType ? typePositions : (isPrice ? pricePositions : (defaultPositions[Math.min(Math.max(count, 1), 5)] || defaultPositions[5])));
        Array.from(group.querySelectorAll('[data-lbx-quiz-option]')).forEach((card) => {
          if (!visibleCards.includes(card)) {
            card.style.setProperty('display', 'none', 'important');
            card.style.removeProperty('grid-column');
            card.style.removeProperty('grid-row');
          }
        });

        visibleCards.forEach((card, index) => {
          const pos = positions[index] || ['1 / span 12', String(index + 1)];
          card.style.setProperty('grid-column', pos[0], 'important');
          card.style.setProperty('grid-row', pos[1], 'important');
          card.style.setProperty('width', 'auto', 'important');
          card.style.setProperty('min-width', '0', 'important');
          card.style.setProperty('max-width', 'none', 'important');
          card.style.setProperty('display', 'flex', 'important');
          card.style.setProperty('visibility', 'visible', 'important');
          card.style.setProperty('opacity', '1', 'important');
        });
      };

      quiz.querySelectorAll('.lbxw-quiz__options').forEach((group) => {
        const visibleCards = Array.from(group.querySelectorAll('[data-lbx-quiz-option]')).filter((card) => {
          return !card.hidden && !card.classList.contains('is-branch-hidden');
        });

        group.dataset.visibleCount = String(visibleCards.length);
        group.classList.toggle('lbxw-quiz__options--one', visibleCards.length === 1);
        group.classList.toggle('lbxw-quiz__options--two', visibleCards.length === 2);
        group.classList.toggle('lbxw-quiz__options--three', visibleCards.length === 3);
        group.classList.toggle('lbxw-quiz__options--four', visibleCards.length === 4);
        group.classList.toggle('lbxw-quiz__options--five', visibleCards.length >= 5);

        group.querySelectorAll('[data-lbx-quiz-option]').forEach((card) => {
          for (let i = 1; i <= 6; i += 1) card.classList.remove(`lbxw-card-pos-${i}`);
          if (card.hidden || card.classList.contains('is-branch-hidden')) {
            card.style.setProperty('display', 'none', 'important');
            card.style.setProperty('grid-column', 'auto', 'important');
            card.style.setProperty('grid-row', 'auto', 'important');
            card.style.setProperty('width', '0', 'important');
            card.style.setProperty('min-width', '0', 'important');
            card.style.setProperty('max-width', '0', 'important');
          }
        });
        visibleCards.forEach((card, index) => {
          card.classList.add(`lbxw-card-pos-${Math.min(index + 1, 6)}`);
        });
        applyCardPlacement(group, visibleCards);
      });
    };

    const stepHasVisibleChoices = (stepIndex) => {
      const step = steps[stepIndex];
      if (!step) return false;
      const choices = Array.from(step.querySelectorAll('[data-lbx-quiz-option]'));
      return !choices.length || choices.some((choice) => !choice.hidden && !choice.classList.contains('is-branch-hidden'));
    };

    const isCurrentAnswered = () => {
      const key = questionKeys[current];
      if (!key) return true;
      if (key === 'altura') return Boolean(state.altura && state.talla);
      return Boolean(getCleanText(state[key]));
    };

    function updateNavState() {
      if (prev) prev.disabled = current === 0;
      if (next) {
        next.disabled = !isCurrentAnswered();
        next.textContent = current >= steps.length - 1 ? i18n.apply : i18n.next;
      }
    }

    const setStep = (index) => {
      updateBranchOptions();
      let target = Math.max(0, Math.min(index, steps.length - 1));
      const direction = target >= current ? 1 : -1;
      while (target > 0 && target < steps.length - 1 && !stepHasVisibleChoices(target)) target += direction;
      current = Math.max(0, Math.min(target, steps.length - 1));
      steps.forEach((step, stepIndex) => step.classList.toggle('is-active', stepIndex === current));
      quiz.dataset.lbxStepIndex = String(current);
      quiz.classList.toggle('is-final-step', current >= steps.length - 1);
      quiz.querySelectorAll('[data-lbx-mini-step]').forEach((item) => {
        const itemIndex = Number(item.dataset.lbxMiniStep || 0);
        item.classList.toggle('is-active', itemIndex === current);
        item.classList.toggle('is-done', itemIndex < current);
      });
      if (progress) progress.style.width = `${((current + 1) / steps.length) * 100}%`;
      if (counter) counter.textContent = `${i18n.question} ${current + 1} ${i18n.of} ${steps.length}`;
      quiz.classList.remove('has-validation-error');
      const shell = quiz.querySelector('.lbxw-quiz__shell');
      if (shell) requestAnimationFrame(() => { try { shell.scrollTop = 0; } catch (e) {} });
      updateNavState();
    };

    const ensureQuizPortal = () => {
      let portal = document.querySelector('[data-lbx-quiz-portal-root]');
      if (!portal) {
        portal = document.createElement('div');
        portal.className = 'lbxw-quiz-portal-root';
        portal.setAttribute('data-lbx-quiz-portal-root', '');
        portal.setAttribute('aria-hidden', 'true');
        document.body.appendChild(portal);
      }
      if (quiz.parentNode !== portal) portal.appendChild(quiz);
      quiz.classList.add('lbxw-quiz--portal');
      syncQuizTheme();
      portal.setAttribute('aria-hidden', 'false');
      return portal;
    };

    const openQuiz = () => {
      lastFocused = document.activeElement;
      const portal = ensureQuizPortal();
      lockScrollY = window.scrollY || document.documentElement.scrollTop || 0;
      previousScrollBehavior = document.documentElement.style.scrollBehavior || '';
      document.documentElement.style.scrollBehavior = 'auto';
      syncQuizTheme();
      quiz.classList.add('is-open');
      quiz.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('lbxw-quiz-lock');
      document.body.classList.add('lbxw-quiz-body-lock');
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      portal.style.zIndex = '2147483647';
      setStep(0);
      window.setTimeout(() => quiz.querySelector('.lbxw-quiz__close')?.focus({ preventScroll: true }), 60);
    };

    const closeQuiz = () => {
      quiz.classList.remove('is-open');
      quiz.setAttribute('aria-hidden', 'true');
      const portal = quiz.closest('[data-lbx-quiz-portal-root]');
      if (portal) portal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('lbxw-quiz-lock');
      document.body.classList.remove('lbxw-quiz-body-lock');
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      window.scrollTo(0, lockScrollY || 0);
      document.documentElement.style.scrollBehavior = previousScrollBehavior;
      syncQuizTheme();
      if (lastFocused && typeof lastFocused.focus === 'function') {
        window.setTimeout(() => {
          try { lastFocused.focus({ preventScroll: true }); } catch (e) {}
        }, 30);
      }
    };

    const goNext = () => {
      if (!isCurrentAnswered()) {
        quiz.classList.add('has-validation-error');
        const currentStep = steps[current];
        const firstOption = currentStep?.querySelector('[data-lbx-quiz-option], [data-lbx-quiz-height]');
        if (firstOption && typeof firstOption.focus === 'function') firstOption.focus({ preventScroll: true });
        return;
      }

      if (current >= steps.length - 1) {
        window.location.href = buildLaboschFilterUrl(quiz, state);
        return;
      }

      setStep(current + 1);
    };

    if (openers.length) requestAnimationFrame(() => { try { ensureQuizPortal(); } catch (e) {} });

    openers.forEach((opener) => {
      opener.addEventListener('click', (event) => {
        event.preventDefault();
        openQuiz();
      });
    });

    closers.forEach((closer) => closer.addEventListener('click', closeQuiz));

    quiz.querySelectorAll('[data-lbx-quiz-option]').forEach((option) => {
      option.addEventListener('click', () => {
        const question = option.dataset.question;
        if (!question) return;

        quiz.querySelectorAll(`[data-lbx-quiz-option][data-question="${question}"]`).forEach((item) => item.classList.remove('is-selected'));
        option.classList.add('is-selected');

        state[question] = option.dataset.value || option.textContent.trim();
        const visibleLabel = option.querySelector('b')?.textContent?.trim();
        displayState[question] = visibleLabel || state[question];

        if (question === 'tipo') {
          state.categoryKey = option.dataset.categoryKey || normalizeAdvisorKey(option.dataset.filterCategory || state[question]);
          state.category = option.dataset.filterCategory || state.categoryKey;
          state.discipline = option.dataset.filterDiscipline || '';
          state.disciplineKey = option.dataset.disciplineKey || '';
          resetQuestion('uso');
          resetQuestion('terreno');
          updateBranchOptions();
        }

        if (question === 'uso') {
          if (option.dataset.categoryKey) {
            state.categoryKey = option.dataset.categoryKey;
            state.category = option.dataset.categoryKey;
          }
          state.useKey = option.dataset.useKey || normalizeAdvisorKey(state[question]);
          state.disciplineKey = option.dataset.disciplineKey || state.disciplineKey || '';
          state.discipline = state.disciplineKey || state.discipline;
          resetQuestion('terreno');
          updateBranchOptions();
        }

        if (question === 'terreno') {
          state.terrainKey = option.dataset.terrainKey || normalizeAdvisorKey(state[question]);
          state.terrainDiscipline = option.dataset.disciplineKey || state.terrainDiscipline || '';
          if (option.dataset.disciplineKey) state.disciplineKey = option.dataset.disciplineKey;
        }

        if (question === 'presupuesto') {
          state.budgetKey = option.dataset.budgetKey || normalizeAdvisorKey(state[question]);
          state.priceMin = option.dataset.priceMin || '';
          state.priceMax = option.dataset.priceMax || '';
        }

        updateSummary();
        updateNavState();
        quiz.classList.remove('has-validation-error');

        if (current < steps.length - 1) {
          window.setTimeout(() => {
            if (!quiz.classList.contains('is-open')) return;
            if (steps[current]?.dataset.lbxQuestion === question) goNext();
          }, 190);
        }
      });
    });

    if (heightInput) {
      heightInput.addEventListener('input', () => updateHeight(heightInput.value));
      heightInput.addEventListener('change', () => updateHeight(heightInput.value));
    }
    if (minus) minus.addEventListener('click', () => updateHeight(Number(state.altura) - 1));
    if (plus) plus.addEventListener('click', () => updateHeight(Number(state.altura) + 1));

    if (prev) prev.addEventListener('click', () => setStep(current - 1));
    if (next) next.addEventListener('click', goNext);

    quiz.addEventListener('click', (event) => {
      if (event.target === quiz) closeQuiz();
    });

    document.addEventListener('keydown', (event) => {
      if (!quiz.classList.contains('is-open')) return;
      if (event.key === 'Escape') closeQuiz();
      if (event.key === 'Enter' && document.activeElement && document.activeElement.matches('[data-lbx-quiz-option]')) {
        event.preventDefault();
        goNext();
      }
    });

    document.addEventListener('labosch:theme-change', syncQuizTheme);

    updateHeight(state.altura);
    updateSummary();
    setStep(0);
  };

  const roots = document.querySelectorAll('[data-lbx-world-home]');

  const reduceMotion = false; // LABOSCH: forzamos las animaciones de esta sección aunque el navegador tenga reduce-motion activo

  roots.forEach((root) => {
    root.classList.add('lbx-world--js-ready');

    // V32: visual light/dark theme switch for LABOSCH custom sections.
    const themeToggle = root.querySelector('[data-lbx-theme-toggle]');
    if (themeToggle) {
      const storageKey = 'labosch_visual_theme';
      const normalizeTheme = (value) => value === 'light' ? 'light' : 'dark';
      const getSavedTheme = () => {
        try { return window.localStorage.getItem(storageKey); } catch (error) { return null; }
      };
      const saveTheme = (value) => {
        try { window.localStorage.setItem(storageKey, value); } catch (error) {}
      };
      const applyTheme = (value, persist = true) => {
        const theme = normalizeTheme(value);
        root.setAttribute('data-lbx-theme', theme);
        document.documentElement.setAttribute('data-lbx-color-scheme', theme);
        document.body?.setAttribute('data-lbx-color-scheme', theme);
        themeToggle.setAttribute('aria-pressed', theme === 'dark' ? 'true' : 'false');
        themeToggle.setAttribute('aria-label', theme === 'dark' ? 'Cambiar a tema claro' : 'Cambiar a tema oscuro');
        themeToggle.title = theme === 'dark' ? 'Cambiar a tema claro' : 'Cambiar a tema oscuro';
        if (persist) saveTheme(theme);
        document.dispatchEvent(new CustomEvent('labosch:theme-change', { detail: { theme } }));
      };

      const defaultTheme = normalizeTheme(root.dataset.lbxDefaultTheme || root.getAttribute('data-lbx-theme') || 'dark');
      applyTheme(getSavedTheme() || defaultTheme, false);

      themeToggle.addEventListener('click', () => {
        const currentTheme = normalizeTheme(root.getAttribute('data-lbx-theme') || defaultTheme);
        applyTheme(currentTheme === 'dark' ? 'light' : 'dark');
      });
    }
    const scrollProgress = root.querySelector('[data-lbx-scroll-progress]');
    const hero = root.querySelector('[data-lbx-hero]');
    const slides = Array.from(root.querySelectorAll('[data-lbx-slide]'));
    const seconds = Math.max(4, parseInt(root.dataset.heroSeconds || '6', 10));
    const wordHost = root.querySelector('[data-lbx-words]');
    const wordLive = root.querySelector('[data-lbx-word-live]');
    const wordCursor = root.querySelector('[data-lbx-word-cursor]');
    const marqueeTrack = root.querySelector('[data-lbx-marquee]');

    if (scrollProgress) {
      const updateProgress = () => {
        const rect = root.getBoundingClientRect();
        const total = Math.max(1, rect.height - window.innerHeight);
        const passed = Math.min(Math.max(-rect.top, 0), total);
        scrollProgress.style.width = `${(passed / total) * 100}%`;
      };
      updateProgress();
      window.addEventListener('scroll', updateProgress, { passive: true });
      window.addEventListener('resize', updateProgress, { passive: true });
    }

    if (slides.length > 1 && !reduceMotion) {
      let active = slides.findIndex((slide) => slide.classList.contains('is-active'));
      if (active < 0) active = 0;
      window.setInterval(() => {
        slides[active]?.classList.remove('is-active');
        active = (active + 1) % slides.length;
        slides[active]?.classList.add('is-active');
      }, seconds * 1000);
    }

    if (hero && !reduceMotion) {
      hero.addEventListener('pointermove', (event) => {
        const rect = hero.getBoundingClientRect();
        const mx = ((event.clientX - rect.left) / rect.width - 0.5) * 34;
        const my = ((event.clientY - rect.top) / rect.height - 0.5) * 34;
        hero.style.setProperty('--mx', `${mx}px`);
        hero.style.setProperty('--my', `${my}px`);
      }, { passive: true });
    }

    // V9: Typewriter driven by JS textContent. The word is never hidden by CSS.
    if (wordHost && wordLive) {
      try {
        const words = (wordHost.getAttribute('data-lbx-words') || '')
          .split('|')
          .map((word) => word.trim())
          .filter(Boolean);
        if (words.length) {
          let wordIndex = 0;
          let charIndex = words[0].length;
          let mode = 'hold';
          wordLive.textContent = words[0];

          const setWord = (value) => {
            wordLive.textContent = value || '\u00A0';
          };

          const tick = () => {
            const currentWord = words[wordIndex] || words[0];
            if (words.length < 2) {
              setWord(currentWord);
              return;
            }

            if (mode === 'hold') {
              mode = 'erase';
              window.setTimeout(tick, 1150);
              return;
            }

            if (mode === 'erase') {
              charIndex = Math.max(0, charIndex - 1);
              setWord(currentWord.slice(0, charIndex));
              if (charIndex === 0) {
                wordIndex = (wordIndex + 1) % words.length;
                mode = 'write';
                window.setTimeout(tick, 180);
              } else {
                window.setTimeout(tick, 26);
              }
              return;
            }

            const nextWord = words[wordIndex] || words[0];
            charIndex = Math.min(nextWord.length, charIndex + 1);
            setWord(nextWord.slice(0, charIndex));
            if (charIndex >= nextWord.length) {
              mode = 'hold';
              window.setTimeout(tick, 1350);
            } else {
              window.setTimeout(tick, 38);
            }
          };

          window.setTimeout(tick, 950);
        }

        if (wordCursor) {
          window.setInterval(() => wordCursor.classList.toggle('is-off'), 470);
        }
      } catch (error) {
        console.warn('LABOSCH hero word animation failed safely:', error);
      }
    }

    // V10: marquee is CSS-only. Do not write inline transform here,
    // because inline JS transform can override the looping keyframes in Shopify previews.


    // V16: rotating offer drop with a visible countdown. Shows 3 products per batch.
    const offerRotators = root.querySelectorAll('[data-lbx-offer-rotator]');
    offerRotators.forEach((rotator) => {
      const cards = Array.from(rotator.querySelectorAll('[data-lbx-offer-card]'));
      const timeNode = rotator.querySelector('[data-lbx-offer-time]');
      const progressNode = rotator.querySelector('[data-lbx-offer-progress]');
      const batchNode = rotator.querySelector('[data-lbx-offer-batch]');
      if (!cards.length) return;

      const perBatch = 3;
      const totalBatches = Math.max(1, Math.ceil(cards.length / perBatch));
      const seconds = Math.max(10, parseInt(rotator.dataset.lbxOfferSeconds || '45', 10));
      let activeBatch = 0;
      let startedAt = performance.now();

      const formatTime = (value) => {
        const total = Math.max(0, Math.ceil(value));
        const minutes = Math.floor(total / 60);
        const secondsLeft = total % 60;
        return `${String(minutes).padStart(2, '0')}:${String(secondsLeft).padStart(2, '0')}`;
      };

      const renderBatch = (nextBatch) => {
        const previous = activeBatch;
        activeBatch = ((nextBatch % totalBatches) + totalBatches) % totalBatches;
        cards.forEach((card, index) => {
          const cardBatch = Math.floor(index / perBatch);
          const isActive = cardBatch === activeBatch;
          const wasActive = cardBatch === previous;
          card.classList.remove('is-leaving');
          if (isActive) {
            card.classList.add('is-active');
          } else if (wasActive && previous !== activeBatch) {
            card.classList.add('is-leaving');
            window.setTimeout(() => {
              card.classList.remove('is-active', 'is-leaving');
            }, 230);
          } else {
            card.classList.remove('is-active');
          }
        });
        if (batchNode) batchNode.textContent = totalBatches > 1 ? `Selección ${activeBatch + 1} / ${totalBatches}` : 'Selección activa';
      };

      renderBatch(0);

      const tickOffer = (now) => {
        const elapsed = (now - startedAt) / 1000;
        const remaining = Math.max(0, seconds - elapsed);
        if (timeNode) timeNode.textContent = formatTime(remaining);
        if (progressNode) progressNode.style.transform = `scaleX(${Math.max(0, remaining / seconds).toFixed(4)})`;

        if (remaining <= 0.02) {
          startedAt = now;
          renderBatch(activeBatch + 1);
        }
        window.requestAnimationFrame(tickOffer);
      };

      window.requestAnimationFrame(tickOffer);
    });

    // V9: Hero image movement driven by JS so it keeps moving even if CSS animations are disabled.
    if (slides.length) {
      try {
        const startedAt = performance.now();
        const animateHeroMedia = (now) => {
          const t = (now - startedAt) / 1000;
          const activeSlide = slides.find((slide) => slide.classList.contains('is-active')) || slides[0];
          if (activeSlide) {
            const scale = 1.065 + Math.sin(t * 0.42) * 0.018;
            const x = Math.sin(t * 0.31) * 1.15;
            const y = Math.cos(t * 0.27) * 0.85;
            activeSlide.style.transform = `scale(${scale.toFixed(4)}) translate3d(${x.toFixed(3)}%,${y.toFixed(3)}%,0)`;
          }
          window.requestAnimationFrame(animateHeroMedia);
        };
        window.requestAnimationFrame(animateHeroMedia);
      } catch (error) {
        console.warn('LABOSCH hero image animation failed safely:', error);
      }
    }

    // V40: navegación real de las categorías visuales aunque algún overlay/script del tema intercepte el clic.
    const openCategoryTile = (tile, event) => {
      if (!tile) return;
      const url = tile.getAttribute('data-lbx-category-url') || tile.getAttribute('href');
      if (!url || url === '#') return;
      if (event && (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button === 1)) return;
      if (event) {
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
      }
      window.location.assign(url);
    };

    root.querySelectorAll('[data-lbx-category-tile]').forEach((tile) => {
      tile.style.cursor = 'pointer';
      tile.setAttribute('role', 'link');
      tile.addEventListener('click', (event) => openCategoryTile(tile, event), true);
      tile.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') openCategoryTile(tile, event);
      }, true);
    });


    const revealItems = root.querySelectorAll('.lbxw-reveal');
    if (revealItems.length) {
      if (!('IntersectionObserver' in window) || reduceMotion) {
        revealItems.forEach((item) => item.classList.add('is-visible'));
      } else {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
        revealItems.forEach((item, index) => {
          item.style.transitionDelay = `${Math.min(index * 35, 260)}ms`;
          observer.observe(item);
        });
      }
    }


    const quiz = root.querySelector('[data-lbx-quiz-modal]');
    if (quiz) initAdvisorModal(quiz, root);
  });

  const initStandaloneAdvisorModals = () => {
    document.querySelectorAll('[data-lbx-advisor-modal]').forEach((quiz) => {
      if (quiz.closest('[data-lbx-world-home]')) return;
      initAdvisorModal(quiz, quiz.closest('[data-lbx-advisor-mount]') || document);
    });
  };

  initStandaloneAdvisorModals();
  document.addEventListener('shopify:section:load', initStandaloneAdvisorModals);
})();
